import Select from "react-select";
import { useStoreLocator } from "./hooks";
import { useComponent, useElement, useLocale, useWidget } from "../../../hooks";
import { base, brandInfo } from "../../../constant";
import "./style.scss";

export const StoreLocator = () => {
  const { t } = useLocale();
  const Link = useElement("Link");
  const Banner = useWidget("Banner");
  const MapWithMarker = useComponent("MapWithMarker");
  const { filteredList, activeCity, assignCity, cities } = useStoreLocator();
  const renderStoreLocatorList = () => {
    return filteredList.map((item, index) => {
      let imageUrl = "";
      try {
        const imageList = typeof item.image === "string" ? JSON.parse(item.image) : item.image;
        if (Array.isArray(imageList) && imageList.length > 0) {
          imageUrl = imageList[0];
        }
      } catch (error) {
        console.error("Error parsing image for item", item.id, error);
      }

      return (
        <div className="storeLocator-single-item" key={index}>
          <div
            className="thumb"
            style={{
              backgroundImage: `url('${base.imageBaseUrl}${imageUrl}')`,
            }}
          ></div>
          <div className="store-content">
            <div className="store-info">
              <div className="content ph20">
                <h3 className="city fs32">{item.addressDetail?.city}</h3>
                <h4 className="area fs18">{item.addressDetail?.area}</h4>
                <p className="mb20">
                  {t("storeLocator.cardDescription")
                    .replace("{brand}", brandInfo.name.capital)
                    .replace("{area}", item.addressDetail?.area || "")
                    .replace("{city}", item.addressDetail?.city || "")}
                </p>
                <Link href={"/store-locator/" + item.slug}>{t("viewMore")}</Link>
              </div>
              <div className="map">
                {item.places && (
                  <MapWithMarker
                    center={item.places[0] ?? []}
                    places={item.places}
                  />
                )}
              </div>
            </div>
            <div className="info-box mt10 lh20">
              <div className="ph20 flex">
                <p className="email">
                  <i className="icon hi-email orange"></i>
                  <span>
                    <b>{t("email")}:</b> {item.email}
                  </span>
                </p>
                <p className="mobile">
                  <i className="icon hi-call orange"></i>
                  <span>
                    <b>{t("mobile")}:</b> {item.mobile}
                  </span>
                </p>
              </div>
              <span className="address mlauto">
                <i className="icon flaticon-pin orange"></i>
                <b>{t("address")}:</b> {item.address}
              </span>
            </div>
          </div>
        </div>
      );
    });
  };

  const customRender = () => {
    return (
      <div className="widget storeLocator-bg">
        <h5 className="widget-title border-bottom">{t("filterByCity")}</h5>
        <Select
          value={activeCity}
          defaultValue={activeCity}
          onChange={assignCity}
          options={cities}
        />
      </div>
    );
  };

  return (
    <>
      <Banner
        title={t("storeLocator.bannerTitle").replace("{brand}", brandInfo.name.capital)}
        align="right"
        image="store-locator-banner.jpg"
        customRender={customRender()}
      />
      <div className="mt40 storeLocator-page jumbo-container mb40">
        <div id="list-wrapper">{renderStoreLocatorList()}</div>
      </div>
    </>
  );
};
